import React from "react";
import { AppBar, Box } from "@mui/material";
import { relative } from "path";

const Header: React.FC = () => {
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ bgcolor: "#fff", color: "#222" }}
    >
      <Box
        sx={{
          justifyContent: "space-between",
          minHeight: 64,
          px: 3,
          pt: 3,
          position: "relative",
          top: "17px",
        }}
      >
        <img
          src="https://www.upgrad.com/_ww3-next/_next/static/media/upgrad-header-logo.325f003e.svg"
          alt="UpGrad Logo"
          style={{ height: "40px" }}
        />
      </Box>
    </AppBar>
  );
};

export default Header;
